import { z } from 'zod';

// Mirror of etl.forecast_run.status CHECK.
export const FORECAST_RUN_STATUSES = [
  'running',
  'succeeded',
  'failed',
  'partial',
] as const;
export type ForecastRunStatus = (typeof FORECAST_RUN_STATUSES)[number];

// Mirror of etl.forecast_run.metric CHECK ('both' = single execution covering both).
export const FORECAST_RUN_METRICS = ['max', 'modal', 'both'] as const;
export type ForecastRunMetric = (typeof FORECAST_RUN_METRICS)[number];

// ---------- Server-shaped row ----------

export const forecastRunSchema = z.object({
  id: z.string(),
  status: z.enum(FORECAST_RUN_STATUSES),
  metric: z.enum(FORECAST_RUN_METRICS),
  horizons: z.array(z.number()),
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
  durationSeconds: z.number().nullable(),
  rowsInput: z.number().nullable(),
  rowsFeatures: z.number().nullable(),
  rowsForecast: z.number().nullable(),
  errorMessage: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ForecastRun = z.infer<typeof forecastRunSchema>;

export const forecastRunDetailSchema = forecastRunSchema.extend({
  parameters: z.record(z.unknown()),
  metadata: z.record(z.unknown()),
});
export type ForecastRunDetail = z.infer<typeof forecastRunDetailSchema>;

// ---------- List filters ----------

export const FORECAST_RUN_SORT_KEYS = ['started', 'finished', 'status'] as const;
export type ForecastRunSortKey = (typeof FORECAST_RUN_SORT_KEYS)[number];

export type SortDirection = 'asc' | 'desc';

export interface ListForecastRunsParams {
  page: number;
  pageSize: number;
  status?: ForecastRunStatus;
  metric?: ForecastRunMetric;
  startedAtFrom?: string;
  startedAtTo?: string;
  sortBy?: ForecastRunSortKey;
  sortDir?: SortDirection;
}
